import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 创建axios实例
const request = axios.create({
  baseURL: 'https://abc.atmcorr.com/api', // 基础URL
  timeout: 15000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 只用 adminToken
    const adminToken = localStorage.getItem('adminToken')
    if (adminToken) {
      config.headers['Authorization'] = `Bearer ${adminToken}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('响应错误：', error)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权或token过期，清除所有相关存储并跳转到登录页
          localStorage.removeItem('adminToken')
          localStorage.removeItem('adminInfo')
          // 获取当前路由路径作为重定向参数
          const currentPath = router.currentRoute.value.fullPath
          router.push({
            path: '/admin/auth/login',
            query: { redirect: currentPath }
          })
          ElMessage.error('登录已过期，请重新登录')
          break
        case 403:
          ElMessage.error('无权限访问')
          break
        default:
          ElMessage.error(error.response.data?.message || '请求失败')
      }
    } else {
      ElMessage.error('网络错误，请稍后重试')
    }
    return Promise.reject(error)
  }
)

export default request